import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/newgoods",
      name: "newgoods",
      component: resolve => require(["@/components/newgoods/newgoods"], resolve)
    },
    {
      path: "/hotsearch",
      name: "hotsearch",
      component: resolve =>
        require(["@/components/hotsearch/hotsearch"], resolve)
    },
    {
      path: "/brand",
      name: "brand",
      component: resolve =>
        require(["@/components/recommendbrand/brand"], resolve)
    },
    {
      path: "/navigation",
      name: "navigation",
      component: resolve =>
        require(["@/components/storenavigation/navigation"], resolve)
    },
    {
      path: "/wetchat",
      name: "wetchat",
      component: resolve =>
        require(["@/components/storenavigation/wetchat"], resolve)
    },
    {
      path: "/seasongoods",
      name: "seasongoods",
      component: resolve =>
        require(["@/components/seasongoods/seasongoods"], resolve)
    },
    {
      path: "/newtowel",
      name: "newtowel",
      component: resolve =>
        require(["@/components/seasongoods/newtowel"], resolve)
    },
    {
      path: "/winprize",
      name: "winprize",
      component: resolve => require(["@/components/prize/winprize"], resolve)
    },
    {
      path: "/goodsupplier",
      name: "goodsupplier",
      component: resolve =>
        require(["@/components/prize/goodsupplier"], resolve)
    },
    {
      path: "/topsupplier",
      name: "topsupplier",
      component: resolve => require(["@/components/prize/topsupplier"], resolve)
    },
    {
      path: "/topstore",
      name: "topstore",
      component: resolve => require(["@/components/prize/topstore"], resolve)
    },
    {
      path: "/purchase", //采购节
      name: "purchase",
      component: resolve => require(["@/components/purchase/purchase"], resolve)
    },
    {
      path: "/tianmao", //天猫二手店
      name: "tianmao",
      component: resolve => require(["@/components/tianmao/tianmao"], resolve)
    },
    {
      path: "/tianmao_detail", //天猫二手店
      name: "tianmao_detail",
      component: resolve =>
        require(["@/components/tianmao/tianmao_detail"], resolve)
    },
    {
      path: "/yiqing", //疫情专题
      name: "yiqing",
      component: resolve => require(["@/components/yiqing/yiqing"], resolve)
    },
    {
      path: "/repeatwork", //企业复工
      name: "repeatwork",
      component: resolve => require(["@/components/yiqing/repeatWork"], resolve)
    },
    {
      path: "/findgoods", //发现好货
      name: "findgoods",
      component: resolve =>
        require(["@/components/findgoods/findgoods"], resolve)
    },
    {
      path: "/hotstore", //人气商家
      name: "hotstore",
      component: resolve =>
        require(["@/components/findgoods/hotstore"], resolve)
    },
    {
      path: "/jiafangcheng", //家纺城专题
      name: "jiafangcheng",
      component: resolve =>
        require(["@/components/special/jiafangcheng"], resolve)
    },
    {
      path: "/zhounian", //4周年
      name: "zhounian",
      component: resolve => require(["@/components/special/zhounian"], resolve)
    },
    {
      path: "/channel", //文章频道
      name: "channel",
      component: resolve => require(["@/components/article/channel"], resolve)
    },
    {
      path: "/articlelist", //文章列表
      name: "articlelist",
      component: resolve =>
        require(["@/components/article/articlelist"], resolve)
    },
    {
      path: "/articledetail", //文章详情
      name: "articledetail",
      component: resolve =>
        require(["@/components/article/articledetail"], resolve)
    },
    {
      path: "/zjfrecord", //找家纺大事记
      name: "zjfrecord",
      component: resolve => require(["@/components/special/zjfrecord"], resolve)
    },
    {
      path: "/videolist", //视频列表
      name: "videolist",
      component: resolve => require(["@/components/video/videolist"], resolve)
    },
    {
      path: "/videodetail", //视频详情
      name: "videodetail",
      component: resolve => require(["@/components/video/videodetail"], resolve)
    },
    {
      path: "/xuanpin", //直播选品
      name: "xuanpin",
      component: resolve => require(["@/components/special/xuanpin"], resolve)
    },
    {
      path: "/mayi", //蚂蚁仓
      name: "mayi",
      component: resolve => require(["@/components/special/mayi"], resolve)
    },
    {
      //收藏夹
      path: "/favorites",
      name: "favorites",
      component: resolve => require(["@/components/favorites/index"], resolve)
    },
    {
      path: "*", //
      name: "unfind",
      component: resolve => require(["@/components/default/unfind"], resolve)
    },
    {
      path: "/zhaohuo", //找货助手
      name: "zhaohuo",
      component: resolve => require(["@/components/special/zhaohuo"], resolve)
    },
    {
      path: "/landingPage", //落地页
      name: "landingPage",
      component: resolve =>
        require(["@/components/special/landingPage"], resolve)
    },
    {
      path: "/antbarn", //蚂蚁仓频道招商
      name: "antbarn",
      component: resolve => require(["@/components/special/antbarn"], resolve)
    },
    {
      path: "/basketball", //篮球赛
      name: "basketball",
      component: resolve =>
        require(["@/components/special/basketball"], resolve)
    },
    {
      path: "/basketballstyle", //篮球赛
      name: "basketballstyle",
      component: resolve =>
        require(["@/components/special/basketballstyle"], resolve)
    },
    {
      path: "/springclose", //春节不打烊
      name: "springclose",
      component: resolve =>
        require(["@/components/special/springclose"], resolve)
    },
    {
      path: "/newyear", //新年活动
      name: "newyear",
      component: resolve =>
        require(["@/components/special/pagesnewyear"], resolve)
    },
    {
      path: "/feedback", // 投诉
      name: "feedback",
      component: resolve => require(["@/components/feedback/index"], resolve)
    },
    {
      path: "/montage", // 红馆拼接广告
      name: "montage",
      component: resolve => require(["@/components/special/montage"], resolve)
    },
    {
      path: "/transportnew", // 运费测算
      name: "transportnew",
      component: resolve =>
        require(["@/components/transport/transportnew"], resolve)
    },
    {
      path: "/fuwuhome", // 服务市场首页
      name: "fuwuhome",
      component: resolve => require(["@/components/fuwu/fuwuhome"], resolve)
    },
    {
      path: "/fuwulist", // 服务市场列表
      name: "fuwulist",
      component: resolve => require(["@/components/fuwu/fuwulist"], resolve)
    },
    {
      path: "/fuwudetail", // 服务市场详情
      name: "fuwudetail",
      component: resolve => require(["@/components/fuwu/fuwudetail"], resolve)
    },
    {
      path: "/fuwuindex", // 服务商首页
      name: "fuwuindex",
      component: resolve => require(["@/components/fuwu/fuwuindex"], resolve)
    },
    {
      path: "/onlineretailertool", // 新页面onlineretailertool
      name: "onlineretailertool",
      component: resolve => require(["@/components/onlineretailertool/index"], resolve)
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js